import { atom } from 'jotai'
import { PanelState } from 'sierra-client/features/sana-now'

export const manageSessionsPanelStateAtom = atom<PanelState>({ type: 'closed' })
